import React, { useState, useEffect } from 'react';
import { STRRoom } from '../types';
import { useResponsive } from '../../hooks/useResponsive';

interface Props {
  room: STRRoom;
  initialTab?: string;
  onSave: (messages: Record<string, string>) => void;
  onClose: () => void;
}

const KEYS = [
  { key: 'msg_contract', label: '예약 확정' },
  { key: 'msg_checkin', label: '입실 안내' },
  { key: 'msg_checkout_prev', label: '퇴실 1일전' },
  { key: 'msg_checkout_day', label: '퇴실 당일' },
];

export default function MessageModal({ room, initialTab, onSave, onClose }: Props) {
  const { isMobile } = useResponsive();
  const [messages, setMessages] = useState<Record<string, string>>({});
  const [activeTab, setActiveTab] = useState(initialTab || 'msg_contract');

  useEffect(() => {
    setMessages({
      msg_contract: room.msg_contract || '',
      msg_checkin: room.msg_checkin || '',
      msg_checkout_prev: room.msg_checkout_prev || '',
      msg_checkout_day: room.msg_checkout_day || '',
    });
  }, [room]);

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.3)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div style={{ background: 'white', borderRadius: 8, padding: isMobile ? 16 : 20, width: isMobile ? 'calc(100vw - 24px)' : 520, maxWidth: 520, maxHeight: '85vh', overflowY: 'auto' }} onMouseDown={(e) => e.stopPropagation()} onClick={(e) => e.stopPropagation()}>
        <h3 style={{ margin: '0 0 12px', fontSize: 16 }}>메시지 템플릿</h3>

        <div style={{ display: 'flex', gap: 4, marginBottom: 12 }}>
          {KEYS.map(({ key, label }) => (
            <button
              key={key}
              onClick={() => setActiveTab(key)}
              style={{
                padding: '6px 12px',
                border: `1px solid ${activeTab === key ? '#1976d2' : '#ccc'}`,
                background: activeTab === key ? '#e3f2fd' : 'white',
                color: activeTab === key ? '#1976d2' : '#666',
                borderRadius: 4,
                cursor: 'pointer',
                fontSize: 12,
              }}
            >
              {label}
            </button>
          ))}
        </div>

        <textarea
          value={messages[activeTab] || ''}
          onChange={(e) => setMessages((p) => ({ ...p, [activeTab]: e.target.value }))}
          style={{ width: '100%', minHeight: 300, padding: 8, border: '1px solid #ddd', borderRadius: 4, fontSize: 13, resize: 'vertical', fontFamily: 'inherit' }}
        />

        <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
          <button onClick={() => onSave(messages)} style={{ flex: 1, padding: 10, background: '#1976d2', color: 'white', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 14 }}>저장</button>
          <button onClick={onClose} style={{ flex: 1, padding: 10, background: 'white', color: '#333', border: '1px solid #ccc', borderRadius: 4, cursor: 'pointer', fontSize: 14 }}>취소</button>
        </div>
      </div>
    </div>
  );
}
